import { render, staticRenderFns } from "./FavouriteTab.vue?vue&type=template&id=39f95386&lang=pug&"
import script from "./FavouriteTab.vue?vue&type=script&lang=ts&"
export * from "./FavouriteTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports